module.exports = __webpack_public_path__ + "assets/img/jtfx1.6d5acb3a.jpg";